import GenericInputForm from 'components/form/genericInputForm'
import InputButton from 'components/form/inputButton'
import React, { Component, Fragment } from 'react'
import { Col, Row } from 'react-bootstrap'
import {
	IAttributesModalFormProps,
	IAttributesModalFormState
} from './AttributesTypes'

class AttributesModalForm extends Component<
	IAttributesModalFormProps,
	IAttributesModalFormState
> {
	constructor(props: IAttributesModalFormProps) {
		super(props)
		this.state = {
			attribData: []
		}
	}

	handleSearchAuto = () => {}

	/**
	 * to render all generic inputs attributes
	 * @returns
	 */
	renderFields = () => {
		const { attributeList } = this.props
		const result: any = []
		attributeList.forEach((element: any) => {
			result.push(
				<GenericInputForm
					style={{ marginLeft: -5 }}
					config={{ ...element, visible: 1, editable: 1 }}
					key={element.cod_atrib}
					handleChange={this.props.handleChangeData}
					handleSearchAuto={this.handleSearchAuto}
					autodata={[]}
				/>
			)
		})

		return result
	}

	render() {
		const { attributeList } = this.props
		return (
			<Fragment>
				<Row>
					<Col className="font-weight-bold mb-3">
						{attributeList && attributeList.item}
					</Col>
					<Col sm={12}>{attributeList && this.renderFields()}</Col>
				</Row>
				<Row>
					<Col className="text-center">
						<InputButton
							valueButton={'Cancelar'}
							onClick={this.props.handleCancelAttributes}
							type={'primary'}
							customStyle={{ minWidth: '145px' }}
						/>
					</Col>
					<Col className="text-center">
						<InputButton
							valueButton={'Aceptar'}
							onClick={this.props.handleConfirmAttributes}
							type={'primary'}
							customStyle={{ minWidth: '145px' }}
						/>
					</Col>
				</Row>
			</Fragment>
		)
	}
}

export default AttributesModalForm
